/*
 * Copyright (C) 2026 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { getIntegration } from "@simplicitycms/simplicity-integration";
import { Logger, red } from "cms/utils/logger.js";

const IntegrationComponent = (props) => {
    const component = props?.component;
    const configuration = parseIfJSON(component?.configuration);
    const type = configuration?.component;

    const { integrationManager, webpage } = useSimpliCity();
    const Integration = getIntegration(integrationManager, type, configuration, webpage);

    return (
        <>
            <div className="simplicity-integration-container" role="region">
                {Integration}

                {configuration && configuration?.verbose &&
                    <pre>{JSON.stringify(configuration, null, 2)}</pre>
                }
            </div>
        </>
    );
};

IntegrationComponent.displayName = "IntegrationComponent";
export { IntegrationComponent };


export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (err) {
        console.log(err.message);
        return false;
    }
    return true;
};

export const parseIfJSON = (str) => {
    if (isJsonString(str)) {
        try {
            return JSON.parse(str);
        } catch (err) {
            Logger.warn(red(`Failed parsing expected JSON: [${err.message}] ${str}`));
        }
    }
    return str;
};
